<template>
  <div>
    <v-card>
      <v-card-title v-if="this.formaction == 'create'">
        <span class="headline">Add Organisation</span>
      </v-card-title>
      <v-card-title v-if="this.formaction == 'edit'">
        <span class="headline">Edit Organisation</span>
      </v-card-title>

      <v-card-text>
        <small>*indicates required field</small>

        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-select
                v-model="Form.portalID"
                :items="portallist"
                item-text="portalName"
                item-value="id"
                chips
                multiple
                label="Portals"
              ></v-select>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                v-model="Form.organisationName"
                v-validate="'required'"
                data-vv-rules="required"
                data-vv-scope="organisationForm"
                :error-messages="errors.collect('organisationForm.organisationName')"
                hide-details
                :counter="50"
                label="Organisation Name*"
                name="organisationName"
              />
            </v-flex>
            <v-flex xs6>
              <v-text-field
                v-model="Form.organisationEmail"
                v-validate="'required'"
                data-vv-rules="required"
                data-vv-scope="organisationForm"
                :error-messages="errors.collect('organisationForm.organisationEmail')"
                hide-details
                :counter="50"
                label="Organisation Email*"
                name="organisationEmail"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click.native="CloseDialog()">Close</v-btn>
        <v-btn color="blue darken-1" flat @click.native="SaveDocument('organisationForm')">Save</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    settings: {
      type: Object,
      default() {
        return {};
      }
    },
    portal: {
      type: Object,
      default() {
        return {};
      }
    },
    form: {
      handler: function() {
        if (this.form.portalID) {
          this.Form.portalID = this.form.portalID;
        }
        if (this.form.organisationName) {
          this.Form.organisationName = this.form.organisationName;
        }
        if (this.form.organisationEmail) {
          this.Form.organisationEmail = this.form.organisationEmail;
        }
      },
      deep: true
    },
    formaction: {
      type: String,
      default: ""
    },
    portallist: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data: () => ({
    Form: {
      portalID: [],
      organisationName: null,
      organisationEmail: null
    }
  }),
  mounted() {
    this.$store.dispatch("portal/readLookups", [
      "lookups",
      this.portal.active.id,
      "portal/setLookups",
      "portal/setLookupsResult"
    ]);
  },
  watch: {
    form() {
      this.Form = this.form;
    }
  },
  methods: {
    CloseDialog() {
      this.$emit("Dialog", false);
    },
    SaveDocument(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (!valid) {
          // do nothing
        } else {
          // console.log("Save Document + " + this.formaction);
          switch (this.formaction) {
            case "create":
              this.$store.dispatch("Settings/createDocument", [
                this.settings.Collection,
                this.Form,
                "Settings/setDocumentResult"
              ]);
              // // console.log(
              //   "this.settings.Collection = " + this.settings.Collection
              // );
              break;
            case "edit":
              var id = this.Form.id;
              //console.log(JSON.stringify(this.Form, null, 2));
              this.Form = this.$omit(this.Form, [
                "vgt_id",
                "originalIndex",
                "id"
              ]);
              //console.log(JSON.stringify(this.Form, null, 2));
              this.$store.dispatch("Settings/updateDocument", [
                this.settings.Collection,
                id,
                this.Form
              ]);
              break;
            default:
              break;
          }
          this.CloseDialog();
        }
      });
    }
  }
};
</script>

<style>
.input-container {
  vertical-align: middle !important;
  display: flex;
  width: 100%;
  margin-bottom: 15px;
}
</style>

